import getStore from '../store';

export default function searchTerms() {
    const store = getStore();

    // if search isn't initialized, don't highlight
    if (!store.searchTerms || !store.searchInitialized) {
        return null;
    }

    return store.searchTerms;
}
